import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Personalised service",
    desc: "You work directly with Eddy — one adviser who knows your full picture. No call centres, no rotating juniors, no generic advice.",
  },
  {
    n: "02",
    title: "Qualified expertise",
    desc: "Registered Tax Agent and ASIC Agent with post-graduate qualifications from UTS and UBSS. Depth you can rely on for complex matters.",
  },
  {
    n: "03",
    title: "Complete confidentiality",
    desc: "Your affairs are handled with the discretion expected of a private wealth office. What we discuss stays between us.",
  },
  {
    n: "04",
    title: "Nationwide reach",
    desc: "Based in Bankstown, NSW and serving discerning clients right across Australia — wherever your interests take you.",
  },
];

export const WhyChooseUs = () => {
  return (
    <section id="why" className="relative py-24 md:py-40 bg-[#0a0a0f] overflow-hidden" data-testid="why-section">
      <div className="absolute top-1/3 -right-32 w-[30rem] h-[30rem] rounded-full bg-[#c9a84c]/5 blur-[120px]" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="flex items-center gap-4 mb-16">
          <span className="font-body text-xs tracking-[0.3em] uppercase text-[#c9a84c]">03 — Why Choose Us</span>
          <span className="h-px flex-1 bg-white/10" />
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-light tracking-tight text-[#f8f9fa] text-3xl sm:text-4xl lg:text-5xl max-w-3xl leading-tight mb-24"
        >
          Four reasons the right people choose us.
        </motion.h2>

        <div className="space-y-px">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.05 }}
              data-testid={`why-chapter-${i}`}
              className="group relative grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start py-12 border-t border-white/10"
            >
              <div className="md:col-span-3 relative">
                <span className="font-display text-7xl lg:text-8xl font-light text-transparent [-webkit-text-stroke:1px_rgba(201,168,76,0.35)] group-hover:[-webkit-text-stroke:1px_rgba(201,168,76,0.8)] transition-all duration-500">
                  {c.n}
                </span>
              </div>
              <div className="md:col-span-9 md:pl-6">
                <h3 className="font-display text-2xl lg:text-3xl text-[#f8f9fa] font-medium mb-4 group-hover:text-[#e8d9a8] transition-colors duration-500">
                  {c.title}
                </h3>
                <p className="font-body text-base text-[#9ba1a6] font-light leading-relaxed max-w-2xl">
                  {c.desc}
                </p>
              </div>
            </motion.div>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
};
